// extracted by mini-css-extract-plugin
export default {"sideMenu":"App_sideMenu__QQbUT","contentful":"App_contentful__7RWum","sider":"App_sider__-cOBb","slider":"App_slider__RRJyn"};